import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, Phone } from 'lucide-react';
import PageShell from './PageShell';

const ContactPage = () => {
  const navigate = useNavigate();

  return (
    <PageShell>
      <div className="pb-8 sm:pb-10">
        <button
          onClick={() => {
            navigate('/');
            window.scrollTo({ top: 0, behavior: 'auto' });
          }}
          className="inline-flex items-center gap-2 text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui text-[#1a1a1a] link-underline"
        >
          <ArrowLeft size={12} />
          BACK TO HOME
        </button>

        <p className="text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui text-[#8b2331] mt-7 sm:mt-8">
          CONTACT
        </p>

        <h1 className="font-serif-display text-[48px] sm:text-[60px] md:text-[72px] leading-[0.98] mt-3 text-[#0f0f0f]">
          Get in Touch
        </h1>
      </div>

      {/* Contact Details */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 border-t-2 divider-line pt-8 sm:pt-10">

        {/* Email */}
        <div className="border-b md:border-b-0 md:border-r divider-line pb-8 md:pb-0 md:pr-8">

          <div className="flex items-center gap-3">
            <Mail
              size={22}
              strokeWidth={1.4}
              className="text-[#8b2331] shrink-0"
            />

            <p className="text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui text-[#0f0f0f]">
              EMAIL
            </p>
          </div>

          <a
            href="mailto:ranadeshravi@gmail.com"
            className="font-serif-display text-[25px] sm:text-[32px] leading-tight text-[#0f0f0f] mt-4 block link-underline break-all"
          >
            ranadeshravi@gmail.com
          </a>

        </div>

        {/* Phone */}
        <div>

          <div className="flex items-center gap-3">
            <Phone
              size={22}
              strokeWidth={1.4}
              className="text-[#8b2331] shrink-0"
            />

            <p className="text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui text-[#0f0f0f]">
              PHONE
            </p>
          </div>

          <a
            href="tel:+918208292542"
            className="font-serif-display text-[27px] sm:text-[32px] leading-tight text-[#0f0f0f] mt-4 block link-underline"
          >
            +91 82082 92542
          </a>

        </div>

      </div>
    </PageShell>
  );
};

export default ContactPage;
